/*
 * COPYRIGHT (c) 2023
 * HONEYWELL INC.,
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React, { useEffect, useState } from 'react';
import './UtilityBillUploadBodyTheme.scss';
import { DataTable } from '@scuf/datatable';
import {
  IAny,
  IDataTableColumn
} from '../DashboardKPIWidgets/IEnergyManagementProps';
import { ICellData } from '@scuf/datatable/dist/components/DataTable/IDataTableInterfaces';
import { Button, Icon, Input, Modal } from '@scuf/common';
import { formmanageBillTableData } from './UtilityManageBillUtils';
import { getSymbolFromCurrency } from '../shared/Utils/Utils';
import {
  IManageBillTableData,
  IMeterDetails
} from './ManageUtilityBillConstants';

import ElectricityBillImage from '../../images/sampleBills.webp';
import GasBillImage from '../../images/SampleBillForGas.webp';
import WaterBillImage from '../../images/Waterbillsample.svg';
import SewerBillImage from '../../images/Sewersamplebill.svg';
import descriptors from '../../locales/en-US/descriptors';
import { useTranslation } from '@scuf/localization';

interface IManageBillTable {
  tableData: IAny;
  meterDetails: IAny;
  onTableDataChange: IAny;
  utilityCellData: IAny;
  isNewBill: boolean;
  units: IAny;
  updateTable: boolean;
  isOcr?: boolean;
  toggleAutomaticBillCategories?: boolean;
  setHasFieldChanged: (hasFieldChanged: boolean) => void;
  setEntryTablePDF: (entryTablePDF: IAny) => void;
  entryTablePDF: boolean;
}

const UtilityManageBillTable = (props: IManageBillTable) => {
  const [expandedRows, setexpandedRows] = useState<IAny>([props.tableData]);
  const [tableData, setTableData] = useState<IAny>([]);
  const [demandUnit, setDemandUnit] = useState<IAny>('');
  const [consumptionUnit, setConsumptionUnit] = useState<IAny>('');
  const [currencyUnit, setCurrencyUnit] = useState<IAny>('');
  const [open, setOpen] = useState(false);
  const [tData, setTData] = useState<IAny>([]);
  const [totalBill, setTotalBill] = useState<IAny>(0);

  const d = descriptors.UtilityBuilder;
  const em = descriptors.energyManagement;
  const [t] = useTranslation();

  const ptableData = props.tableData;

  useEffect(() => {
    // calculateExpandedRows()
    // setexpandedRows([props.tableData])
    const val = props.tableData.reduce(
      (accumulator: number, currentValue: IAny) => {
        if (currentValue.categories !== 'TOTAL BILL AMOUNT') {
          return accumulator + Number(currentValue.cost);
        } else {
          return accumulator;
        }
      },

      0
    );
    setTotalBill(val);
    setTData(props.tableData);
    setTableData(props.tableData);
  }, []);

  const { isNewBill, utilityCellData, units } = props;

  useEffect(() => {
    setDemandUnit(
      units && units.demandUnit
        ? units.demandUnit
        : utilityCellData && utilityCellData.demandUnit
        ? utilityCellData.demandUnit
        : undefined
    );
    setConsumptionUnit(
      units && units.consumptionUnit
        ? units.consumptionUnit
        : utilityCellData && utilityCellData.consumptionUnit
        ? utilityCellData.consumptionUnit
        : undefined
    );
    setCurrencyUnit(
      units && units.currencyUnit
        ? units.currencyUnit
        : utilityCellData && utilityCellData.currencyUnit
        ? utilityCellData.currencyUnit
        : undefined
    );
    // if (units) {
    //   setDemandUnit(units && units.demandUnit ? units.demandUnit : utilityCellData && utilityCellData.demandUnit ?  utilityCellData.demandUnit: undefined);
    //   setConsumptionUnit(units && units.consumptionUnit ? units.consumptionUnit : utilityCellData && utilityCellData.consumptionUnit ?  utilityCellData.consumptionUnit: undefined);
    //   setCurrencyUnit(units && units.currencyUnit ? units.currencyUnit : utilityCellData && utilityCellData.currencyUnit ?  utilityCellData.currencyUnit: undefined);
    // }else if(utilityCellData) {
    //   setDemandUnit(utilityCellData.demandUnit);
    //   setConsumptionUnit(utilityCellData.consumptionUnit);
    //   setCurrencyUnit(utilityCellData.currencyUnit);
    // }
    // if (utilityCellData) {
    //   setDemandUnit(utilityCellData.demandUnit);
    //   setConsumptionUnit(utilityCellData.consumptionUnit);
    //   setCurrencyUnit(utilityCellData.currencyUnit);
    // } else if (units) {
    //   setDemandUnit(units.demandUnit);
    //   setConsumptionUnit(units.consumptionUnit);
    //   setCurrencyUnit(units.currencyUnit);
    // }
  }, []);

  const debounce = (fn: IAny, delay: IAny) => {
    let timer: IAny;
    return (...args: IAny) => {
      clearTimeout(timer);
      setTimeout(() => fn.apply(this, args), delay);
    };
  };

  useEffect(() => {
    // setTableData(JSON.parse(JSON.stringify(props.tableData)))
    if (props.updateTable) {
      const val = props.tableData.reduce(
        (accumulator: number, currentValue: IManageBillTableData) => {
          if (currentValue.categories !== 'TOTAL BILL AMOUNT') {
            return accumulator + Number(currentValue.cost);
          } else {
            return accumulator;
          }
        },

        0
      );
      setTotalBill(val);
      setTData(JSON.parse(JSON.stringify(props.tableData)));
      setTableData(JSON.parse(JSON.stringify(props.tableData)));
      // if (utilityCellData) {
      //   setDemandUnit(utilityCellData.demandUnit);
      //   setConsumptionUnit(utilityCellData.consumptionUnit);
      //   setCurrencyUnit(utilityCellData.currencyUnit);
      // }
    } else {
      if (props.isOcr && props.entryTablePDF) {
        const val = props.tableData.reduce(
          (accumulator: number, currentValue: IManageBillTableData) => {
            if (currentValue.categories !== 'TOTAL BILL AMOUNT') {
              return accumulator + Number(currentValue.cost);
            } else {
              return accumulator;
            }
          },

          0
        );
        setTotalBill(val);
        setTData(JSON.parse(JSON.stringify(props.tableData)));
        setTableData(JSON.parse(JSON.stringify(props.tableData)));

        setDemandUnit(utilityCellData.demandUnit);
        setConsumptionUnit(utilityCellData.consumptionUnit);
        setCurrencyUnit(utilityCellData.currencyUnit);
        props.setEntryTablePDF(false);
      } else {
        // setDemandUnit(units.demandUnit);
        // setConsumptionUnit(units.consumptionUnit);
        // setCurrencyUnit(units.currencyUnit);
      }
    }
  }, [props.updateTable]);

  const expanderTemplate = (
    data: ICellData,
    expandedRows: IAny[]
    // setexpandedRows: React.Dispatch<React.SetStateAction<IAny>>
  ) => {
    const open =
      expandedRows.findIndex(
        (item) => item.categories === data.rowData.categories
      ) >= 0;
    return data.rowData.meterDetails && data.rowData.meterDetails.length ? (
      <div
        onClick={() =>
          toggleExpand(data.rowData, open, expandedRows, setexpandedRows)
        }
      >
        <Icon
          root="common"
          size="small"
          name={open ? 'caret-down' : 'caret-right'}
        />
        {'  ' + t(data.value)}
      </div>
    ) : (
      <div>{'  ' + t(data.value)}</div>
    );
  };

  const renderCategories = (cellData: ICellData) => {
    return expanderTemplate(cellData, expandedRows);
  };

  const toggleExpand = (
    data: IAny,
    open: boolean,
    expandedRows: IAny[],
    setexpandedRows: React.Dispatch<React.SetStateAction<IAny>>
  ) => {
    const expanded = [...expandedRows];
    if (open) {
      let index = expanded.findIndex(
        (item) => item.categories === data.categories
      );
      expanded.splice(index, 1);
    } else {
      expanded.push(data);
    }
    setexpandedRows(expanded);
  };

  useEffect(() => {
    debounce(props.onTableDataChange, 1000)(tableData);
  }, [tableData]);

  const sumTotalForOthers = (tableeData: IManageBillTableData[]) => {
    setTableData(
      tableeData.map((dt: IManageBillTableData) => {
        if (dt.meterDetails && dt.meterDetails.length) {
          if (!isNaN(Number(dt.consumption))) {
            dt.consumption = dt.meterDetails.reduce(
              (accumulator: number, currentValue: IMeterDetails) =>
                accumulator + Number(currentValue.consumption),
              0
            );
            dt.consumption =
              dt.consumption === Math.floor(dt.consumption)
                ? dt.consumption
                : dt.consumption.toFixed(2);
          }
          if (!isNaN(Number(dt.demand))) {
            dt.demand = dt.meterDetails.reduce(
              (accumulator: number, currentValue: IMeterDetails) =>
                accumulator + Number(currentValue.demand),
              0
            );
            dt.demand =
              dt.demand === Math.floor(dt.demand)
                ? dt.demand
                : dt.demand.toFixed(2);
          }
          dt.cost = dt.meterDetails.reduce(
            (accumulator: number, currentValue: IMeterDetails) =>
              accumulator + Number(currentValue.cost),
            0
          );
          dt.cost =
            dt.cost === Math.floor(dt.cost) ? dt.cost : dt.cost.toFixed(2);
        }

        return dt;
      })
    );
    const val = tableeData.reduce(
      (accumulator: number, currentValue: IManageBillTableData) => {
        if (currentValue.categories !== 'TOTAL BILL AMOUNT') {
          return accumulator + Number(currentValue.cost);
        } else {
          return accumulator;
        }
      },

      0
    );
    setTotalBill(val);
    // setTData([...tData])
    // calculateExpandedRows()
  };

  const sumTotal = (tableeData: IManageBillTableData[]) => {
    let costExceptOther = 0;
    let totalBillAmount = 0;
    const tempTableeData = tableeData.map((dt: IManageBillTableData) => {
      if (dt.meterDetails && dt.meterDetails.length) {
        if (!isNaN(Number(dt.consumption))) {
          dt.consumption = dt.meterDetails.reduce(
            (accumulator: number, currentValue: IMeterDetails) =>
              accumulator + Number(currentValue.consumption),
            0
          );
          dt.consumption =
            dt.consumption === Math.floor(dt.consumption)
              ? dt.consumption
              : dt.consumption.toFixed(2);
          costExceptOther += dt.meterDetails.reduce(
            (accumulator: number, currentValue: IMeterDetails) =>
              accumulator + Number(currentValue.cost),
            0
          );
        }
        if (!isNaN(Number(dt.demand))) {
          dt.demand = dt.meterDetails.reduce(
            (accumulator: number, currentValue: IMeterDetails) =>
              accumulator + Number(currentValue.demand),
            0
          );
          dt.demand =
            dt.demand === Math.floor(dt.demand)
              ? dt.demand
              : dt.demand.toFixed(2);
          costExceptOther += dt.meterDetails.reduce(
            (accumulator: number, currentValue: IMeterDetails) =>
              accumulator + Number(currentValue.cost),
            0
          );
        }
        dt.cost = dt.meterDetails.reduce(
          (accumulator: number, currentValue: IMeterDetails) =>
            accumulator + Number(currentValue.cost),
          0
        );
        dt.cost =
          dt.cost === Math.floor(dt.cost) ? dt.cost : dt.cost.toFixed(2);
      } else {
        if (
          dt.categories !== 'Others' &&
          dt.categories !== 'TOTAL BILL AMOUNT'
        ) {
          costExceptOther += Number(dt.cost);
        } else if (dt.categories === 'TOTAL BILL AMOUNT') {
          totalBillAmount = Number(dt.cost);
        }
      }
      return dt;
    });
    setTableData(
      tempTableeData.map((dt: IManageBillTableData) => {
        if (dt.categories === 'Others') {
          dt.cost = totalBillAmount - Number(costExceptOther);
        }
        return dt;
      })
    );
    const val = tempTableeData.reduce(
      (accumulator: number, currentValue: IManageBillTableData) => {
        if (currentValue.categories !== 'TOTAL BILL AMOUNT') {
          return accumulator + Number(currentValue.cost);
        } else {
          return accumulator;
        }
      },

      0
    );
    setTotalBill(val);
    // setTData([...tData])
    // calculateExpandedRows()
  };

  const updateArray = (
    arrData: Array<IAny>,
    category: string,
    type: string,
    value: number | string
  ) => {
    if (arrData) {
      arrData[arrData.findIndex((arr) => arr.categories === category)][type] =
        value === '' ? value : Number(value);
    }
  };

  const updateMeterList = (
    isConsumption: IAny,
    isMeter: IAny,
    category: string,
    type: string,
    value: number | string
  ) => {
    const tempTableData: IManageBillTableData[] = [...tableData];
    if (!isMeter) {
      updateArray(
        tempTableData[
          tempTableData.findIndex((arr: IManageBillTableData) =>
            !isNaN(Number(isConsumption))
              ? arr.categories === 'Consumption'
              : arr.categories === 'Demand'
          )
        ].meterDetails,
        category,
        type,
        value
      );
    } else {
      updateArray(tempTableData, category, type, value);
    }
    // calculateExpandedRows();
    props.toggleAutomaticBillCategories
      ? sumTotal(tempTableData)
      : sumTotalForOthers(tempTableData);
  };

  const getArrayValue = (
    arrData: Array<IAny>,
    category: string,
    type: string,
    value: number
  ) => {
    if (arrData)
      return arrData[arrData.findIndex((arr) => arr.categories === category)][
        type
      ];
  };

  const calculateValue = (
    isConsumption: boolean,
    isMeter: boolean,
    category: string,
    type: string,
    value: number
  ) => {
    if (!isMeter) {
      if (isConsumption)
        return getArrayValue(
          tableData[
            tableData.findIndex(
              (arr: IManageBillTableData) => arr.categories === 'Consumption'
            )
          ].meterDetails,
          category,
          type,
          value
        );
      else {
        return getArrayValue(
          tableData[
            tableData.findIndex(
              (arr: IManageBillTableData) => arr.categories === 'Demand'
            )
          ].meterDetails,
          category,
          type,
          value
        );
      }
    } else {
      return getArrayValue(tableData, category, type, value);
    }
  };

  const calculateTotalCost = () => {
    return tableData.reduce(
      (accumulator: number, currentValue: IAny) =>
        accumulator + Number(currentValue.cost),
      0
    );
  };

  const checkForInteger = (num: number) => {
    return Number.isInteger(num);
  };

  const disableInputWhenNoUnit = () => {
    if (!units.consumptionUnit || !units.currencyUnit) {
      return true;
    }
  };

  const disableInputWhenNoDemand = (cellData: IAny) => {
    if (
      props.utilityCellData.demandUnit === '' ||
      props.utilityCellData.demandUnit === null
    ) {
      return cellData.rowData.categories.includes('(') &&
        !isNaN(Number(cellData.rowData.demand))
        ? true
        : false;
    }
    return false;
  };

  const renderInputs = (cellData: IAny) => {
    if (
      !isNaN(cellData.rowData[cellData.field]) &&
      cellData.rowData.categories !== 'TOTAL BILL AMOUNT'
    ) {
      return (
        <div className="Manage-Bill_Table_Input">
          <Input
            placeholder={
              (props.utilityCellData &&
                props.utilityCellData.integrationType === 'Automatic' &&
                !props.isNewBill) ||
              (cellData &&
                cellData.rowData &&
                ['Consumption', 'Demand'].includes(
                  cellData.rowData.categories
                )) ||
              disableInputWhenNoDemand(cellData)
                ? ''
                : t(d.ENTER_PLACEHOLDER)
            }
            type={'number'}
            disabled={
              (props.utilityCellData &&
                props.utilityCellData.integrationType === 'Automatic' &&
                !props.isNewBill) ||
              (cellData &&
                cellData.rowData &&
                ['Consumption', 'Demand'].includes(
                  cellData.rowData.categories
                )) ||
              disableInputWhenNoDemand(cellData) ||
              disableInputWhenNoUnit() ||
              (cellData.rowData.categories === 'Others' &&
                props.toggleAutomaticBillCategories)
            }
            value={calculateValue(
              Number(cellData.rowData.consumption) === 0 ||
                cellData.rowData.consumption,
              cellData.rowData.sr,
              cellData.rowData.categories,
              cellData.field,
              cellData.value
            )}
            onKeyDown={(e: any) => {
              if (e.keyCode === 69 || e.keyCode === 189) {
                e.preventDefault();
              } else {
                return true;
              }
            }}
            onChange={(event: IAny) => {
              props.setHasFieldChanged(true);
              updateMeterList(
                cellData.rowData.consumption,
                cellData.rowData.sr,
                cellData.rowData.categories,
                cellData.field,
                event
              );
            }}
          />
        </div>
      );
    } else if (
      !isNaN(cellData.rowData[cellData.field]) &&
      cellData.rowData.categories === 'TOTAL BILL AMOUNT'
    ) {
      // return cellData.value;
      return totalBill === Math.floor(totalBill)
        ? totalBill
        : totalBill.toFixed(2);
    } else {
      return null;
    }
  };

  const columns: IAny = [
    {
      className: 'SR',
      header: 'SR.',
      unit: null,
      field: 'sr',
      initialWidth: '3%'
    },
    {
      className: 'categories',
      header: t(d.CATEGORIES),
      unit: null,
      field: 'categories',
      cellDataRenderer: renderCategories,
      initialWidth: '5%'
    },
    {
      className: 'Consumption',
      header: t(em.ENERGYUSAGECONSUMPTION),
      unit: consumptionUnit,
      field: 'consumption',
      cellDataRenderer: renderInputs,
      initialWidth: '4%'
    },
    {
      className: 'Demand',
      header: t(em.DEMAND),
      unit: demandUnit,
      field: 'demand',
      cellDataRenderer: renderInputs,
      initialWidth: '4%'
    },
    {
      className: 'Cost',
      header: t(em.COSTSCOPE),
      unit: currencyUnit && getSymbolFromCurrency(currencyUnit),
      field: 'cost',
      cellDataRenderer: renderInputs,
      initialWidth: '4%'
    }
  ];

  const columnsWhenNoDemand: IAny = [
    {
      className: 'SR',
      header: 'SR.',
      unit: null,
      field: 'sr',
      initialWidth: '3%'
    },
    {
      className: 'categories',
      header: t(d.CATEGORIES),
      unit: null,
      field: 'categories',
      cellDataRenderer: renderCategories,
      initialWidth: '5%'
    },
    {
      className: 'Consumption',
      header: t(em.ENERGYUSAGECONSUMPTION),
      unit: consumptionUnit,
      field: 'consumption',
      cellDataRenderer: renderInputs,
      initialWidth: '4%'
    },
    {
      className: 'Demand',
      header: '',
      unit: demandUnit,
      field: '',
      cellDataRenderer: renderInputs,
      initialWidth: '4%'
    },
    {
      className: 'Cost',
      header: t(em.COSTSCOPE),
      unit: currencyUnit && getSymbolFromCurrency(currencyUnit),
      field: 'cost',
      cellDataRenderer: renderInputs,
      initialWidth: '4%'
    }
  ];

  const utilitySpecificColumns =
    props.utilityCellData.utilityType === 'Electricity'
      ? columns
      : columnsWhenNoDemand;

  const columnsForMeters: IAny = [
    {
      header: 'SR',
      unit: null,
      field: 'sr',
      initialWidth: '3%'
    },
    {
      header: t(d.CATEGORIES),
      unit: null,
      field: 'categories',
      //   cellDataRenderer: renderCategories,
      initialWidth: '4%'
    },
    {
      header: t(em.ENERGYUSAGECONSUMPTION),
      unit: 'kWh',
      field: 'consumption',
      cellDataRenderer: renderInputs,
      initialWidth: '4%'
    },
    {
      header: t(em.DEMAND),
      unit: 'kVA',
      field: 'demand',
      cellDataRenderer: renderInputs,
      initialWidth: '4%'
    },
    {
      header: t(em.COSTSCOPE),
      unit: 'INR',
      field: 'cost',
      cellDataRenderer: renderInputs,
      initialWidth: '4%'
    }
  ];

  const rowExpansionTemplate = (
    data: IAny,
    columnDetails: IDataTableColumn[],
    rowcellDataRendererForChildren: (cellData: ICellData) => JSX.Element
  ) => {
    return (
      <div className="UtilityBill-row-expansion">
        <DataTable data={data.meterDetails} showHeader={false}>
          <DataTable.Column initialWidth="0%" field="" header="" />
          {columns.map((column: IAny) => {
            return (
              <DataTable.Column
                align={'left'}
                key={column.field}
                className={column.className}
                field={column.field}
                header={
                  column.unit
                    ? `${column.header} (${column.unit})`
                    : `${column.header}`
                }
                // sortable={column.sortable}
                renderer={column.cellDataRenderer}
                initialWidth={column.initialWidth}
              />
            );
          })}
        </DataTable>
      </div>
    );
  };

  const SampleBillMapper: any = {
    Electricity: {
      image: ElectricityBillImage,
      title: 'Sample Electricity Bill'
    },
    Gas: { image: GasBillImage, title: 'Sample Gas Bill' },
    Water: { image: WaterBillImage, title: 'Sample Water Bill' },
    Sewer: { image: SewerBillImage, title: 'Sample Sewer Bill' }
  };

  const renderModelForSampleBill = () => {
    return (
      <Modal
        className="emaas-utility-bill-modal"
        closeIcon={true}
        onClose={() => setOpen(false)}
        open={open}
        closeOnDimmerClick={false}
      >
        <Modal.Header className="utility-bill-modal-header">
          {/* {props.utilityCellData.utilityType === 'Electricity'
            ? 'Sample Electricity Bill'
            : 'Sample Gas Bill'} */}
          {SampleBillMapper[props.utilityCellData.utilityType]?.title}
        </Modal.Header>
        <Modal.Content className="utlity-modal-content">
          <div className="sample-bill">
            <img
              // src={
              //   props.utilityCellData.utilityType === 'Electricity'
              //     ? ElectricityBillImage
              //     : props.utilityCellData.utilityType === 'Water'
              //     ? WaterBillImage
              //     : props.utilityCellData.utilityType === 'Sewer'
              //     ? SewerBillImage
              //     : GasBillImage
              // }
              src={SampleBillMapper[props.utilityCellData.utilityType]?.image}
              alt="sample-bill"
              width="100%"
              height="100%"
            />
          </div>
        </Modal.Content>
      </Modal>
    );
  };

  return (
    <div>
      <div className="Manage-Bill-Table-Header">
        {/* <span>Bill Categories</span> */}
        <div className="Manage-Bill-Table-subheader">
          {renderModelForSampleBill()}
          <span>
            {t(d.INPUTCATEGORIES, {
              utilityType: utilityCellData.utilityType.toLowerCase()
            })}
            <Button type="link" onClick={() => setOpen(true)}>
              {t(d.REFERSAMPLEBILL)}.
            </Button>
          </span>
        </div>
      </div>
      <DataTable
        className="Manage-Bill-Table"
        data={tData}
        rowExpansionTemplate={rowExpansionTemplate as any}
        expandedRows={JSON.parse(JSON.stringify(expandedRows))}
        // reorderableColumns={true}
        //   resizableColumns={true}
        //   scrollable={true}
        //   scrollWidth="90%"
        width={'90%'}
      >
        {utilitySpecificColumns.map((column: IAny) => {
          return (
            <DataTable.Column
              align={'left'}
              key={column.field}
              className={column.className}
              field={column.field}
              header={
                column.unit
                  ? `${column.header} (${column.unit})`
                  : `${column?.header}`
              }
              //   sortable={column.sortable}
              renderer={column.cellDataRenderer}
              initialWidth={column.initialWidth}
            />
          );
        })}
      </DataTable>
    </div>
  );
};

export default UtilityManageBillTable;
